import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Airtable from "airtable";
import logo from "./logo-sigal_3.png";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "./OrderDetails.css";

const sizes = {
	"S/39/4": { shoes: "39", adult: "S", child: "4" },
	"M/40/6": { shoes: "40", adult: "M", child: "6" },
	"L/41/8": { shoes: "41", adult: "L", child: "8" },
	"XL/42/10": { shoes: "42", adult: "XL", child: "10" },
	"2XL/43/12": { shoes: "43", adult: "2XL", child: "12" },
	"3XL/44/14": { shoes: "44", adult: "3XL", child: "14" },
	"4XL/45/16": { shoes: "45", adult: "4XL", child: "16" },
	"5XL/46/18": { shoes: "46", adult: "5XL", child: "18" },
	36: { shoes: "36" },
	"36-5": { shoes: "36.5" },
	37: { shoes: "37" },
	"37-5": { shoes: "37.5" },
	38: { shoes: "38" },
	"38-5": { shoes: "38.5" },
	"39-5": { shoes: "39.5" },
	"40-5": { shoes: "40.5" },
	"41-5": { shoes: "41.5" },
	"42-5": { shoes: "42.5" },
	"43-5": { shoes: "43.5" },
	"44-5": { shoes: "44.5" },
	"45-5": { shoes: "45.5" },
	"46-5": { shoes: "46.5" },
	47: { shoes: "47" },
	"47-5": { shoes: "47.5" },
	48: { shoes: "48" },
	"One Size": { shoes: "One Size", adult: "One Size", child: "One Size" },
};

const InfoDiv = (props) => {
	return (
		<div>
			{props.name}:{" "}
			<span style={{ textDecoration: "underline", whiteSpace: "pre" }}>
				{!props.val || props.val === ""
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</div>
	);
};

const InfoSpan = (props) => {
	return (
		<span style={{ ...props.style }}>
			{props.name}:{" "}
			<span
				style={{
					textDecoration: "underline",
					whiteSpace: "pre",
					fontWeight: "normal",
				}}
			>
				{!props.val || props.val === ""
					? " ".repeat(props.placeTimes ?? 50)
					: props.val}
			</span>
		</span>
	);
};

const TopPart = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;

	@media screen and (max-width: 40em) {
		flex-direction: column-reverse;
		margin-bottom: 30px;
	}
`;

const BottomPart = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;

	& .part1 {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	& .part2 {
		display: flex;
		flex-direction: column;
		max-width: 60%;
		gap: 8px;
	}

	@media screen and (max-width: 40em) {
		padding-bottom: 24px;
		& .part1 {
			max-width: none;
		}

		& .part2 {
			max-width: none;
		}
	}
`;

function useInput({ type }) {
	const [value, setValue] = useState("");
	const input = (
		<input
			value={value}
			onChange={(e) => setValue(e.target.value)}
			type={type}
		/>
	);
	return [value, input];
}

const Fulfillment = (props) => {
	const [orderDetails, setOrderDetails] = useState({});
	const [orderItems, setOrderItems] = useState([]);
	const routerParams = useParams();
	const [approverName, approverNameInput] = useInput({ type: "text" });
	const [approverId, approverIdInput] = useInput({ type: "text" });

	const base = new Airtable({
		apiKey:
			"patBXQgJPv4W41ktc.c7c4725c447b5fbef08fcd945de907f7ff20eb53ee6213c0f546fc811def4547",
	}).base(routerParams.base || "appZ1xuAo89gyeDRW");

	useEffect(() => {
		base("הזמנות").find(routerParams.id, function (err, record) {
			if (err) {
				setOrderDetails({ error: "הזמנה לא קיימת במערכת" });
				console.error(err);
				return;
			}
			setOrderDetails(record.fields);
		});
	}, [routerParams.id]);

	useEffect(() => {
		let newItems = [];
		base("פריטי הזמנות")
			.select({
				view: "API",
				filterByFormula: `{הזמנה} = '${orderDetails["מס הזמנה"]}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					const fieldsM = records.map((rec) => rec.fields);
					newItems = [...newItems, ...fieldsM];

					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						setOrderItems({ error: "חלה שגיאה בקריאת הנתונים" });
						return;
					}

					setOrderItems(newItems);
				}
			);
	}, [orderDetails]);

	const getItemSizes = (item) => {
		let type = "shoes";
		let itemType =
			item.rawType && item.rawType !== "" ? item.rawType : item.type[0];
		switch (itemType) {
			case "בוגרים":
				type = "adult";
				break;
			case "הדפסים":
				type = "adult";
				break;
			case "ילדים":
				type = "child";
				break;
			case "נעליים":
				type = "shoes";
				break;
			default:
				type = "shoes";
				break;
		}
		const itemSizes = Object.keys(sizes)
			.filter((size) => item[size] && item[size] !== 0)
			.map((size, idx) => {
				return (
					<>
						{idx > 0 && <> | </>}
						<InfoSpan name={sizes[size][type]} val={item[size] + ""} />
					</>
				);
			});

		return itemSizes;
	};

	return (
		<div
			style={{
				fontFamily: "Assistant, sans-serif",
				color: "#804c9e",
				fontWeight: "bold",
				padding: "20px",
				width: "100%",
				height: "100vh",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<TopPart>
				<Header>
					<div style={{ display: "flex", flexDirection: "column" }}>
						<span>
							<span style={{ fontSize: "26px" }}>הזמנה</span> מס׳:{" "}
							{orderDetails["מס הזמנה"]}
						</span>
						<span style={{ fontSize: "20px" }}>אישור סחורה</span>
						<InfoDiv
							name="תאריך"
							val={new Date(orderDetails["תאריך הזמנה"]).toLocaleDateString()}
						/>
						<InfoDiv name="סוכן" val={orderDetails["agentName"]} />
					</div>
					<div style={{ textAlign: "center" }}>
						<div>
							תמנע 7 חולון 5881307 | טל' 03-5580668 | פקס 03-5591101
							<br />
							ח.פ 513830638 | www.sigal-ba.co.il
						</div>
						<br />
					</div>
					<img width="300px" alt="logo" src={logo} />
				</Header>
				<div
					style={{
						display: "flex",
						justifyContent: "space-evenly",
						gap: "8px",
						flexWrap: "wrap",
					}}
				>
					<InfoDiv name="לכבוד" val={orderDetails["clientName"]} />
					<InfoDiv name="כתובת" val={orderDetails["כתובת לקוח"]} />
					<InfoDiv name="ח״פ/ע״מ" val={orderDetails["חפ"]} />
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-evenly",
						gap: "8px",
						flexWrap: "wrap",
					}}
				>
					<InfoDiv name="איש קשר" val={orderDetails["contactName"]} />
					<InfoDiv name="טלפון" val={orderDetails["לקוח טלפון"]} />
					<InfoDiv name="טלפון נוסף" val={orderDetails["איש קשר נוסף טלפון"]} />
					<InfoDiv name="אימייל" val={orderDetails["מייל לקוח"]} />
				</div>
			</TopPart>
			<div style={{ flexGrow: "1", padding: "20px" }}>
				<Table className="order" style={{ border: "1px solid black" }}>
					<Thead>
						<Tr>
							<Th>פריט</Th>
							<Th>צבע</Th>
							<Th>
								<InfoSpan name="מידה" val="כמות" />
							</Th>
							<Th>כמות</Th>
							<Th>הדפסה/רקמה</Th>
							<Th>הערות</Th>
						</Tr>
					</Thead>
					<Tbody>
						{orderItems
							.filter((item) => {
								return item["type"] && item["type"][0] !== "הדפסים";
							})
							.map((item, idx) => (
								<Tr key={idx}>
									<Td>
										{item["itemName"]}{" "}
										{item["itemNameRussian"] ? (
											<div>{item["itemNameRussian"]}</div>
										) : (
											""
										)}
									</Td>
									<Td>{item["צבע"]}</Td>
									<Td>{getItemSizes(item)}</Td>
									<Td>{item["totalQuantity"]}</Td>
									<Td>
										<InfoDiv name="הדפסה?" val={item["הדפסה?"] ? "☑️" : "❌"} />
										<InfoDiv name="רקמה?" val={item["רקמה?"] ? "☑️" : "❌"} />
									</Td>
									<Td style={{ width: "15%" }}></Td>
								</Tr>
							))}
					</Tbody>
				</Table>
			</div>
			<BottomPart>
				<div className="part1">
					<div>
						<InfoSpan placeTimes={35} name="מכונה (Машина)" />
						<InfoSpan placeTimes={35} name="ידני (Ручную)" />
						<InfoSpan placeTimes={35} name="רקמה(Вышивка)" />
					</div>
					<div style={{ marginBottom: "14px" }}>
						<InfoSpan placeTimes={35} name="ללא הדפסה ((Без надписи " />
						<InfoSpan placeTimes={35} name="דיגיטל (Дигитал) " />
						<br />
					</div>
					<InfoDiv name="הערות" val={orderDetails["הערות להזמנה"]} />
					<InfoDiv name="הערות אריזה" val={orderDetails["הערות אריזה"]} />
					<InfoDiv
						name="זמן אספקה"
						val={
							(orderDetails["זמן אספקה"] ? orderDetails["זמן אספקה"] : "") +
							(orderDetails["תאריך אספקה ספציפי"]
								? " - " + orderDetails["תאריך אספקה ספציפי"]
								: "")
						}
					/>
					<InfoDiv name="תנאי תשלום" val={orderDetails["תנאי תשלום"]} />
					<InfoDiv
						name="צורת תשלום"
						val={
							(orderDetails["אופן תשלום"] ? orderDetails["אופן תשלום"] : "") +
							(orderDetails["סכום מקדמה"]
								? " - " + orderDetails["סכום מקדמה"] + "₪"
								: "")
						}
					/>
					<InfoDiv
						name="לקוח חדש?"
						val={orderDetails["לקוח חדש"] ? "כן" : "לא"}
					/>
					<InfoDiv
						name="סוג גרפיקת לוגו"
						val={orderDetails["סוג גרפיקת לוגו"]}
					/>
					<InfoDiv name="סוג אריזה" val={orderDetails["סוג אריזה"]} />
				</div>
			</BottomPart>
			{Object.keys(orderDetails).length === 0 && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					טוען, אנא המתינו...
				</div>
			)}

			{orderDetails["error"] && (
				<div
					style={{
						position: "absolute",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					{orderDetails["error"]}
				</div>
			)}
		</div>
	);
};

export default Fulfillment;
